<template>
  <fragment>
    <div v-if="type === 'images'">
      <div class="flex justify-between items-center my-4">
        <h5 v-if="title"><i class="dot"></i> {{ title }}</h5>
        <div v-if="!readonly">
          <vs-button color="secondary" @click="handleClickAddFileButton"> 파일추가 </vs-button>
        </div>
      </div>
      <input ref="fileInput" type="file" style="display: none" accept="image/gif, image/jpeg, image/png" @change="handleChangeFile" />

      <div class="flex flex-col gap-4 mt-8">
        <div :key="index_image" v-for="(image, index_image) in files" class="relative" style="width: 1024px; margin-left: auto; margin-right: auto">
          <div v-if="!readonly" class="delete-button-container" @click.stop="(e) => deleteImage(e, image)">
            <img style="position: relative; width: 12px; height: 12px" src="@/assets/images/icon/icon-close.svg" />
          </div>

          <a :href="image.path" target="_blank" class="cursor-pointer">
            <img :src="image.path" :alt="image.name" class="w-full" />
          </a>
        </div>
      </div>
      <div v-if="readonly && files.length === 0" class="none-images">
        <p>이미지 미등록</p>
        <p class="s-text">등록된 이미지가 없습니다.</p>
      </div>
    </div>

    <label v-if="type === 'only-image' || (type === 'images' && !readonly)" class="w-full h-full only-image" :class="type === 'images' && 'type-images'" @click="onClickImage" @dragenter="onDrag" @dragover="onDrag" @drop="onDrop">
      <div v-if="!file || (!file.path && !readonly)" style="display: grid; justify-items: center">
        <img class="pb-2" style="width: 36px; height: 32px; position: relative" src="@/assets/images/icon/icon-file-upload.svg" />
        <span style="font-size: 16px; font-weight: bold">이미지 업로드</span>
        <span style="font-size: 14px; font-weight: normal">이미지를 드롭하거나 여기를 클릭하여 업로드하세요.</span>
      </div>
      <input v-if="!file || (!readonly && !file.path)" :id="id" type="file" @change="handleChangeFile" style="display: none" accept="image/png, image/jpeg" />
      <div v-if="file && file.path">
        <img :src="file.path" />
        <div v-if="!readonly" class="delete-button-container" @click.stop="deleteImage">
          <img style="position: relative; width: 12px; height: 12px" src="@/assets/images/icon/icon-close.svg" />
        </div>
      </div>
    </label>

    <label v-else-if="type !== 'images'" style="display: flex; position: relative" :title="file.fileName">
      <input ref="fileInput" type="file" @change="handleChangeFile" style="display: none" />
      <ml-input class="w-full file-input" readonly :value="file.fileName" @click="handleClickAddFileButton" :placeholder="placeholder" />
      <vs-icon
        v-if="!readonly"
        icon-pack="feather"
        icon="icon-upload"
        class=""
        style="margin-top: 6px; margin-bottom: 6px; padding-left: 6px; padding-right: 6px; position: absolute; top: 0; right: 0; bottom: 0; font-size: 24px; border-left: 1px solid #cdcdcd; background-color: transparent"
        :style="file.id > 0 ? 'right:40px' : ''"
      ></vs-icon>
      <a
        v-if="file.id > 0"
        @click.prevent.stop="onClickDownloadFile"
        style="
          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          line-height: 1.7;
          border-left: 1px solid #cdcdcd;
          margin-top: 6px;
          margin-bottom: 6px;
          margin-right: 1px;
          padding-left: 6px;
          padding-right: 6px;
          color: #6670cb;
          background-color: white;
          cursor: pointer;
        "
      >보기</a
      >
    </label>
  </fragment>
</template>

<script>
import { downloadFile } from "@/util/DataUtil";


export default {
  name: "FileUploader",
  props: {
    type: {
      type: String,
      default: "",
    },
    value: {
      type: Object | Array | String,
      default: () => {},
    },
    readonly: Boolean,
    placeholder: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      id: "file_upload",
      file: this.value,
      files: [],
    };
  },
  watch: {
    value: {
      handler(value) {
        console.log("this.type", this.type)
        if (this.type === "images") {
          this.files = value;
        } else {
          this.file = value;
        }
      },
    },
    files: {
      immediate: true,
      deep: true,
      handler(value) {
        if (this.type === "images") {
          this.$emit("input", value);
          this.$emit("change", value);
        }
      },
    },
    file: {
      immediate: true,
      deep: true,
      handler(value) {
        if (this.type !== "images") {
          this.$emit("input", value);
          this.$emit("change", value);
        }
      },
    },
  },
  created() {
    if (this.value) {
      this.file = {
        id: this.value.id,
        fileName: this.value.fileName,
        fileSize: this.value.fileSize,
        path: this.value.path,
        thumb: this.value.thumb,
      };
    }
  },
  methods: {
    // 이미지 업로드 API가 5분 이상이 걸리면 Timeout
    async fetchDataWithTimeout(promise, timeout = 300000) {
      let timer;

      // 타임아웃 프라미스 생성
      const timeoutPromise = new Promise((_, reject) => {
        timer = setTimeout(() => {
          reject(new Error("Timeout"));
        }, timeout);
      });

      // 주어진 promise와 timeoutPromise 중 하나가 완료될 때까지 경합
      return Promise.race([promise, timeoutPromise])
        .then((result) => {
          clearTimeout(timer); // 타이머 정리
          return result;
        })
        .catch((error) => {
          clearTimeout(timer); // 타이머 정리
          throw error; // 에러 재발생
        });
    },

    async file_upload(files) {
      if (files.length > 0) {
        this.loading(true);

        this.fetchDataWithTimeout(this.$store.dispatch("file/FILE_UPLOAD", files[0]))
          .then(() => {
            const file = this.$store.state.file.uploadedFile;
            const data = {
              id: file.id,
              fileName: file.fileName,
              fileSize: file.fileSize,
              path: file.path,
              thumb: file.thumb,
            };

            if (this.type === "images") {
              this.files.push(data);
            } else {
              this.file = data;
            }
            this.loading(false);
          })
          .catch((err) => {
            this.loading(false);
            this.customAlert("이미지 업로드가 실패하였습니다.");
          });
      }
    },

    deleteImage(evt, data) {
      if (this.type === "images") {
        const fd = this.files.filter((file) => file.id !== data.id);
        this.files = JSON.parse(JSON.stringify(fd));
      } else this.file = {};
      evt.preventDefault();
    },

    onClickImage() {
      if (this.file.path) {
        window.open(this.file.path, "_blank");
      }
    },

    onDrop(evt) {
      if (evt && evt.dataTransfer && evt.dataTransfer.files) {
        this.changeFile(evt.dataTransfer.files);
      }
      evt.preventDefault();
    },

    onDrag(evt) {
      evt.preventDefault();
    },

    handleClickAddFileButton() {
      if (!this.readonly) {
        this.$refs.fileInput.value = null;
        this.$refs.fileInput.click();
      }
    },
    handleChangeFile(event) {
      this.changeFile(event.target.files);
    },

    changeFile(files) {
      this.file_upload(files);
      this.$emit("change");
    },

    /**
     * 파일을 다운로드 한다
     *
     * template 내에 있는 a 태그에 download 속성을 추가해봤으나,
     * href 속성에 설정된 URL 값이 "절대경로" 일 경우, download 속성이 동작하지 않는 것을 확인했음
     */
    onClickDownloadFile() {
      const fileName = this.file.fileName;
      const hashedFileName = this.file.path.split("/").pop();

      downloadFile(fileName, hashedFileName);
    },

    loading(open) {
      const loadingDialog = new CustomEvent("loadingDialog", {
        detail: {
          open,
        },
      });
      window.dispatchEvent(loadingDialog);
    },
    customAlert(msg) {
      const customAlert = new CustomEvent("customAlert", {
        detail: {
          title: "알림",
          message: msg,
        },
      });
      window.dispatchEvent(customAlert);
    },
  },
};
</script>

<style lang="scss" scoped>
.type-images {
  max-width: 1024px;
  height: 200px !important;
  background: white !important;
  margin: 14px auto;
}
.none-images {
  max-width: 1024px;
  background: white;
  padding: 70px 0;
  border: 1px dashed #cdcdcd;
  border-radius: 6px;
  margin: auto;

  p {
    font-size: 16px;
    font-weight: 700;
    text-align: center;

    &.s-text {
      font-size: 14px;
      font-weight: 400;
    }
  }
}

.only-image {
  cursor: pointer;
  position: relative;

  border: 2px dashed #cdcdcd;
  border-radius: 6px;
  background-color: #f5f5f5;

  color: #3c3c3c;
  font-size: 18px;
  font-weight: bold;

  display: flex;
  align-items: center;
  justify-content: center;

  img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 6px;
  }
}
.delete-button-container {
  position: absolute;
  top: -8px;
  right: -8px;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 24px;
  height: 24px;
  border-radius: 999px;
  border: 1px solid #222;
}
</style>
